/**
 * Lesson quizzes reveal whether an answer was right. The course completion
 * quiz only stores the answer and moves on, because the verdict stays hidden
 * until the run is over.
 */
export interface HiddenVerdictProps {
  /** Defaults to true. False collects the answer and calls `onAdvance`. */
  revealFeedback?: boolean;
  /** Primary button label while the verdict stays hidden. */
  advanceLabel?: string;
  /** Called after the answer was stored. Not called when storing failed. */
  onAdvance?: () => void;
}

export const collectsWithoutVerdict = (revealFeedback?: boolean): boolean =>
  revealFeedback === false;

/**
 * Stores the answer, then moves on. A rejected store leaves the question in
 * place: the caller has already shown why it failed.
 */
export const advanceAfterCollect = async (
  submit: () => Promise<unknown>,
  onAdvance?: () => void
): Promise<void> => {
  try {
    await submit();
  } catch {
    return;
  }
  onAdvance?.();
};
